import { render, staticRenderFns } from "./sSelectedZona.vue?vue&type=template&id=5a72b85e"
import script from "./sSelectedZona.vue?vue&type=script&lang=js"
export * from "./sSelectedZona.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports